module.exports = __webpack_public_path__ + "img/cardRequest.254ef08d.svg";